import { render, staticRenderFns } from "./JournalTemplateList.vue?vue&type=template&id=be059be0&"
import script from "./JournalTemplateList.vue?vue&type=script&lang=js&"
export * from "./JournalTemplateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports